export default __webpack_public_path__ + "static/media/provesional_restoration_lower_46_4@2x.1ea2d87c.png";